<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">营销系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>动物分红记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="bonus">
      <div style="margin-bottom: 20px">
        <el-autocomplete
          class="inline-input"
          v-model="pagination.coinType"
          :fetch-suggestions="querySearch"
          placeholder="请输入币种"
          @select="handleSelect"
          @keyup.native.enter="handleSearch"
        >
          <i
            class="el-icon-close el-input__icon"
            slot="suffix"
            @click="cleanSearchCoin"
            style="cursor: pointer"
          >
          </i>
        </el-autocomplete>
        <el-button type="primary" class="btn" @click="refreshList"
          >搜索</el-button
        >
        <el-button type="primary" @click="addBonus" class="btn">添加</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="coinType" label="币种" width="180">
        </el-table-column>
        <el-table-column
          prop="devideTime"
          label="分红时间"
          width="180"
          :formatter="dateFormat"
        >
        </el-table-column>
        <el-table-column prop="dividePeople" label="分红人数">
        </el-table-column>
        <el-table-column prop="divideAmount" label="分红总量">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="deleteItem(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="page-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="pagination.size"
          layout="sizes, prev, pager, next"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
      <!-- <currency-introduction-list
        @refresh="refreshList"
      ></currency-introduction-list> -->
    </div>
    <el-dialog :title="title" :visible.sync="addBox" width="30%">
      <div class="bonus">
        <el-form label-width="80px">
          <el-form-item label="币种">
            <el-autocomplete
              class="inline-input"
              v-model="coinType"
              :fetch-suggestions="querySearch"
              placeholder="请输入币种"
              @select="handleSelect"
              @keyup.native.enter="handleSearch"
            >
              <i
                class="el-icon-close el-input__icon"
                slot="suffix"
                @click="cleanSearchCoin"
                style="cursor: pointer"
              >
              </i>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="分红时间">
            <el-date-picker
              v-model="devideTime"
              type="datetime"
              placeholder="选择分红日期时间"
              default-time="12:00:00"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="分红人数">
            <el-input v-model="dividePeople" placeholder="请输入分红人数">
            </el-input>
            <span class="unit">人</span>
          </el-form-item>
          <el-form-item label="分红总量">
            <el-input v-model="divideAmount" placeholder="请输入分红总量">
            </el-input>
            <span class="unit">{{ coinType }}</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确定</el-button>
            <el-button type="primary" @click="onClose">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "./api";
import { mapActions, mapState } from "vuex";
import CurrencyIntroductionList from "./components/list";
import moment from "moment";
export default {
  components: {
    CurrencyIntroductionList,
  },
  data() {
    return {
      title: "",
      addBox: false,
      isAdd: false,
      coinType: "",
      devideTime: "",
      dividePeople: null,
      divideAmount: null,
      id: "",
      pagination: {
        coinType: "",
        page: 1,
        size: 10,
        total: 0,
      },
      tableData: [],
    };
  },
  created() {
    this.refreshList();
    this.getAllSupportCoin();
  },
  computed: {
    ...mapState("bonusDivide", ["list", "listTotal"]),
  },
  methods: {
    ...mapActions("bonusDivide", ["getList", "addBonus"]),
    handleSizeChange(val) {
      this.pagination.size = val;
      api
        .getList({
          ...this.pagination,
        })
        .then((res) => {
          this.tableData = res.data.records;
        });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pagination.page = val;
      api
        .getList({
          ...this.pagination,
        })
        .then((res) => {
          this.tableData = res.data.records;
        });
    },
    refreshList() {
      api
        .getList({
          ...this.pagination,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        });
    },
    addBonus() {
      this.addBox = true;
      this.isAdd = true;
      this.title = "添加币种";
      this.id = "";
      // this.getAllSupportCoin();
    },
    onClose() {
      this.coinType = "";
      this.devideTime = "";
      this.dividePeople = "";
      this.divideAmount = "";
      this.addBox = false;
    },
    edit(item) {
      this.title = "编辑币种";
      this.coinType = item.coinType;
      this.devideTime = new Date(item.devideTime);
      this.dividePeople = item.dividePeople;
      this.divideAmount = item.divideAmount;
      this.id = item.id;
      this.addBox = true;
      this.pagination.page = 1;
      this.refreshList();
    },
    deleteItem(id) {
      this.$confirm("确认删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          api.deleteDivide({ id: id }).then(({ data }) => {
            this.$message.success("删除成功！");
            this.refreshList();
          });
        })
        .catch(() => {});
    },
    onSubmit() {
      if (
        this.coinType &&
        this.devideTime &&
        this.dividePeople &&
        this.divideAmount
      ) {
        api
          .addBonus({
            coinType: this.coinType,
            devideTime: this.devideTime.getTime(),
            dividePeople: this.dividePeople,
            divideAmount: this.divideAmount,
            id: this.id,
          })
          .then((res) => {
            console.log(res);
            this.coinType = "";
            this.devideTime = "";
            this.dividePeople = null;
            this.divideAmount = null;
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.addBox = false;
            this.isAdd = false;
            this.pagination.page = 1;
            this.refreshList();
          });
      }
    },
    getAllSupportCoin() {
      api.getAllSupportCoin().then(({ data }) => {
        this.coinTypes = data;
      });
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.coinTypes;
      results = queryString
        ? coinList.filter(this.createFilter(queryString))
        : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v,
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.coinTypes;
      return (tempData) => {
        return tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect() {},
    cleanSearchCoin() {
      this.coinType = "";
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style lang="less">
.bonus {
  margin-top: 20px;
  .btn {
    margin-left: 20px;
  }
  .unit {
    padding-left: 10px;
    color: #919191;
  }
  .el-input {
    width: 260px;
  }
  .el-input__inner {
    width: 260px;
  }
  .page-box {
    text-align: right;
    margin-top: 15px;
    .el-input {
      width: 100px;
    }
    .el-input__inner {
      width: 100px;
    }
  }
}
</style>